import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "narrow-view" }

import BowlerRegistrationRequestForm from '@/components/forms/BowlerRegistrationRequestForm.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerRegistrationRequestView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('bowler-registration.heading')), 1),
    _createVNode(BowlerRegistrationRequestForm)
  ]))
}
}

})